// extracted by mini-css-extract-plugin
module.exports = {"root--transparentHeader":"Page_root--transparentHeader__ljW4k","root":"Page_root__VxhLn","skipToMain":"Page_skipToMain__h_mw9","rotation":"Page_rotation__9BSJ4"};